import React, { useContext, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import 'moment/locale/en-au';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { SearchBarContext } from '../../../../components/SearchBar';
import SearchBarRow from '../../../../components/SearchBar/SearchBarRow';
import DatePicker, { registerLocale } from 'react-datepicker';
import de from 'date-fns/locale/de';
registerLocale('de', de);
import es from 'date-fns/locale/es';
registerLocale('es', es);
import fr from 'date-fns/locale/fr';
import PropTypes from "prop-types";
registerLocale('fr', fr);

const PrimarySearchItems = (props) => {
  const intl = useIntl();
  const { register } = useContext(SearchBarContext);
  const { control } = useContext(SearchBarContext);

  const orgAdminRoles = useMemo(() => (
    <>
      <option key='org-admin' value="true">
        {intl.formatMessage({ id: 'users.roles.org-admin' })}
      </option>
      <option key='student' value="false">
        {intl.formatMessage({ id: 'users.roles.student' })}
      </option>
    </>
  ), []);

  const adminRoles = useMemo(() => (
    <>
      <option key='admin' value="true">
        {intl.formatMessage({ id: 'users.roles.admin' })}
      </option>
      <option key='user' value="false">
        {intl.formatMessage({ id: 'users.roles.user' })}
      </option>
    </>
  ), []);

  return (
    <SearchBarRow>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'users.search.email-field' })}</label>
        <input className="form-control" {...register('email')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'users.search.first-name-field' })}</label>
        <input className="form-control" {...register('firstName')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'users.search.last-name-field' })}</label>
        <input className="form-control" {...register('lastName')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'users.search.role-field' })}</label>
        <Controller
          control={control}
          name={props.forOrgUser ? 'orgAdmin' : 'admin'}
          render={({ field }) => (
            <select
              name={props.forOrgUser ? 'orgAdmin' : 'admin'}
              className="form-control"
              onChange={(e) => field.onChange(e.target.value)}
              defaultValue="true"
            >
              <option key="0" value="">
                {intl.formatMessage({ id: 'users.roles.show-all' })}
              </option>
              {props.forOrgUser ? orgAdminRoles : adminRoles}
            </select>
          )}
        />
      </div>
    </SearchBarRow>
  );
};

const SecondarySearchItems = () => {
  const intl = useIntl();
  const { control } = useContext(SearchBarContext);

  return (
    <SearchBarRow>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'users.search.last-login-field' })}</label>
        <div className="date-range">
          <Controller
            control={control}
            name="lastLoginStart"
            render={({ field }) => (
              <DatePicker
                name="lastLoginStart"
                className="form-control"
                placeholderText={intl.formatMessage({ id: 'shared.forms.start_date' })}
                selected={field.value ? moment(field.value).toDate() : undefined}
                onChange={(date) => field.onChange(date)}
                dateFormat={window._FLAIM_DATE_FORMAT}
                locale={window._FLAIM_LOCALE}
              />
            )}
          />

          <Controller
            control={control}
            name="lastLoginEnd"
            render={({ field }) => (
              <DatePicker
                name="lastLoginEnd"
                className="form-control"
                placeholderText={intl.formatMessage({ id: 'shared.forms.end_date' })}
                selected={field.value ? moment(field.value).toDate() : undefined}
                onChange={(date) => field.onChange(date)}
                dateFormat={window._FLAIM_DATE_FORMAT}
              />
            )}
          />
        </div>
      </div>
    </SearchBarRow>
  );
};

PrimarySearchItems.propTypes = {
  forOrgUser: PropTypes.bool,
};

export { PrimarySearchItems, SecondarySearchItems };